/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { JuridicoFacilState, TypesThemeTypes } from 'store/modules/juridico_facil_store/types';
import SearchJuridico from 'components/atoms/search_juridico';
import Select from 'react-select';
import { captalizeFirstLetter } from 'services/captalize';
import {
  areas_list_subtopics,
  areas_temas,
  get_area,
  get_themes,
  get_tipos,
  list_subtopics,
  type,
} from 'store/modules/juridico_facil_store/actions';
import Loader from 'components/atoms/loader';
import EmptyResult from 'components/atoms/empty_result';
import Pagination from 'components/atoms/pagination';
import OpenTutorial from 'components/atoms/open_tutorial';
import { Container } from './styles';

interface JuridicoThemesProps {
  params: {
    id?: string;
    tipo?: string;
  };
}

const JuridicoThemes = (props: JuridicoThemesProps) => {
  const dispatch = useDispatch();
  const [tipo, setTipo] = useState<TypesThemeTypes>();
  const [area, setArea] = useState<TypesThemeTypes>();
  const [temas, setTemas] = useState<TypesThemeTypes>();
  const [subTema, setSubTema] = useState<TypesThemeTypes>();
  const [currentPage, setCurrentPage] = useState<number>(1);

  const { params } = props;
  const { juridico, request } = useSelector<ApplicationState, JuridicoFacilState>(
    (state) => state.session.juridico,
  );

  const paginate = (currentPage = 1) => {
    if (currentPage) {
      setCurrentPage(currentPage);
    }
  };

  useEffect(() => {
    if (params.id) {
      const findItemById = (list: TypesThemeTypes[], id: number) =>
        list?.find((option) => option?.id === id);

      const idFromParams = parseInt(params?.id, 10);
      setTipo(findItemById(juridico?.lista_tipos, idFromParams));
      setArea(findItemById(juridico?.lista_areas, idFromParams));
    }
  }, []);

  useEffect(() => {
    if (params.id) {
      const findItemById = (list: TypesThemeTypes[], id: number) =>
        list?.find((option) => option?.id === id);

      const idFromParams = parseInt(params?.id, 10);
      const temaId = idFromParams === 1 ? 24 : 74;
      setTemas(findItemById(juridico?.lista_temas, temaId));
    }
  }, [juridico?.lista_temas]);

  useEffect(() => {
    const fetchData = async () => {
      document.title = 'Jurídico Fácil - ConLicitação';

      if (params?.tipo === 'tipos' && params?.id) {
        dispatch(get_tipos(params.id, currentPage));
      }

      if (params?.tipo === 'areas' && params?.id) {
        dispatch(get_area(params.id, currentPage));
      }

      if (params?.tipo === 'temas' && params?.id) {
        dispatch(get_themes(params.id, currentPage));
      }
    };

    fetchData();
    // sem currentPage aqui, clicar na paginação só pintava o número: nada era rebuscado
  }, [params.id, params.tipo, currentPage]);

  // trocar de tipo/área precisa voltar para a primeira página
  useEffect(() => {
    setCurrentPage(1);
  }, [params.id, params.tipo]);

  useEffect(() => {
    if (tipo?.id && params?.tipo === 'tipos') {
      dispatch(type(tipo?.id));
    }
    if (area?.id && params?.tipo === 'areas') {
      dispatch(get_area(String(area?.id)));
    }
  }, [tipo?.id, area?.id]);

  const handleSelectChange = (selected: any) => {
    setTipo(selected);
  };

  const handleSelectArea = (selected: any) => {
    setArea(selected);
  };

  const handleSelectTemas = (selected: any) => {
    setTemas(selected);
    dispatch(list_subtopics(String(selected?.id)));
    dispatch(areas_temas(String(selected?.id)));
  };

  const handleSelectSubtemas = (selected: any) => {
    setSubTema(selected);
    dispatch(areas_list_subtopics(String(selected?.id)));
  };

  return (
    <Container>
      <div className="mt-5 py-2">
        <div className="container p-4 mt-2">
          <div className="row">
            <div className="col-md-12">
              <div className="d-md-flex d-block align-items-center mb-3">
                <h4 className="mb-1 mr-3 font-weight-bold">Jurídico Fácil</h4>
                <OpenTutorial type="modal" source="juridico" />
              </div>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/juridico">Início</a>
                  </li>
                  <li className="breadcrumb-item active font-weight-bold" aria-current="page">
                    {params?.tipo && captalizeFirstLetter(params?.tipo)}
                  </li>
                </ol>
              </nav>
              <SearchJuridico params={[]} />
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-md-3">
              {params?.tipo === 'tipos' ? (
                <div className="card mb-2">
                  <div className="card-header">Tipos</div>
                  <div className="card-body">
                    <Select
                      name="types"
                      closeMenuOnSelect
                      options={juridico?.lista_tipos || []}
                      getOptionLabel={(option) => option?.descricao}
                      className="basic-multi-select"
                      styles={{
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isFocused ? '#007bff' : 'transparent',
                          color: state.isFocused ? '#fff' : '#666',
                        }),
                      }}
                      onChange={handleSelectChange}
                      value={tipo}
                    />
                  </div>
                </div>
              ) : (
                <>
                  {params?.tipo !== 'temas' && (
                    <div className="card mb-2">
                      <div className="card-header">Áreas</div>
                      <div className="card-body">
                        <Select
                          name="types"
                          closeMenuOnSelect
                          options={juridico?.lista_areas || []}
                          getOptionLabel={(option) => option?.descricao}
                          className="basic-multi-select"
                          styles={{
                            option: (provided, state) => ({
                              ...provided,
                              backgroundColor: state.isFocused ? '#007bff' : 'transparent',
                              color: state.isFocused ? '#fff' : '#666',
                            }),
                          }}
                          onChange={handleSelectArea}
                          value={area}
                        />
                      </div>
                    </div>
                  )}

                  <div className="card mb-2">
                    <div className="card-header">Temas</div>
                    <div className="card-body">
                      <Select
                        name="types"
                        closeMenuOnSelect
                        options={juridico?.lista_temas || []}
                        getOptionLabel={(option) => option?.descricao}
                        className="basic-multi-select"
                        styles={{
                          option: (provided, state) => ({
                            ...provided,
                            backgroundColor: state.isFocused ? '#007bff' : 'transparent',
                            color: state.isFocused ? '#fff' : '#666',
                          }),
                        }}
                        onChange={handleSelectTemas}
                        value={temas}
                      />
                    </div>
                  </div>
                  <div className="card mb-2">
                    <div className="card-header">Subtemas</div>
                    <div className="card-body">
                      <Select
                        name="types"
                        closeMenuOnSelect
                        options={juridico?.lista_subtemas || []}
                        getOptionLabel={(option) => option?.descricao}
                        className="basic-multi-select"
                        styles={{
                          option: (provided, state) => ({
                            ...provided,
                            backgroundColor: state.isFocused ? '#007bff' : 'transparent',
                            color: state.isFocused ? '#fff' : '#666',
                          }),
                        }}
                        onChange={handleSelectSubtemas}
                        value={subTema}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="col-md-9">
              {request?.tipos?.loading ? (
                <div className="text-center">
                  <Loader />
                </div>
              ) : (
                juridico?.acervo?.map((acervo) => (
                  <div className="card mb-3">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-12">
                          <nav id="idx_breadcrumb">
                            <ol className="breadcrumb breadcrumb-custom ml-0 pl-0">
                              <li className="breadcrumb-item">
                                <a href="#" data-abc="true">
                                  <strong>{acervo.tipo}</strong>
                                </a>
                              </li>
                              <li className="breadcrumb-item">
                                <a href="#" data-abc="true">
                                  {acervo.area}
                                </a>
                              </li>
                              {!!acervo.tema && (
                                <li className="breadcrumb-item">
                                  <a href="#" data-abc="true">
                                    {acervo.tema}
                                  </a>
                                </li>
                              )}
                              {!!acervo.subtema && (
                                <li className="breadcrumb-item">
                                  <a href="#" data-abc="true">
                                    {acervo.subtema}
                                  </a>
                                </li>
                              )}
                            </ol>
                          </nav>
                        </div>
                        <div className="col-md">
                          <a
                            href={`/juridico/show/${acervo.id}${
                              acervo.fonte ? `?fonte=${acervo.fonte}` : ''
                            }`}
                            className="link_acervo"
                            dangerouslySetInnerHTML={{
                              __html: acervo.enunciado,
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              )}
              {request?.search?.loaded && juridico?.acervo?.length === 0 && (
                <EmptyResult title="Desculpe!" description="Ops, nada encontrado!" />
              )}
              {juridico?.acervo && (
                <div className="row d-print-none mt-3">
                  <div className="col-md-12 px-4 mb-5">
                    <Pagination
                      postsPerPage={10}
                      totalPosts={juridico?.total_page_area}
                      paginate={paginate}
                      currentPage={currentPage}
                      firstAndLastPage
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default JuridicoThemes;
